import "./kendo.core.js";
import "./kendo.router.js";
import "./kendo.view.js";
import "./kendo.fx.js";
import "./kendo.dom.js";
import "./kendo.data.odata.js";
import "./kendo.data.xml.js";
import "./kendo.data.js";
import "./kendo.ooxml.js";
import "./kendo.excel.js";
import "./kendo.data.signalr.js";
import "./kendo.binder.js";
import "./kendo.drawing.js";
import "./kendo.validator.js";
import "./kendo.userevents.js";
import "./kendo.draganddrop.js";
import "./kendo.mobile.scroller.js";
import "./kendo.groupable.js";
import "./kendo.reorderable.js";
import "./kendo.resizable.js";
import "./kendo.sortable.js";
import "./kendo.selectable.js";
import "./kendo.chat.js";
import "./kendo.button.js";
import "./kendo.speechtotextbutton.js";
import "./kendo.buttongroup.js";
import "./kendo.breadcrumb.js";
import "./kendo.switch.js";
import "./kendo.pager.js";
import "./kendo.popup.js";
import "./kendo.notification.js";
import "./kendo.tooltip.js";
import "./kendo.list.js";
import "./kendo.calendar.js";
import "./kendo.datepicker.js";
import "./kendo.dateinput.js";
import "./kendo.drawer.js";
import "./kendo.multiviewcalendar.js";
import "./kendo.autocomplete.js";
import "./kendo.dropdownlist.js";
import "./kendo.dropdowntree.js";
import "./kendo.combobox.js";
import "./kendo.multiselect.js";
import "./kendo.multicolumncombobox.js";
import "./kendo.colorpicker.js";
import "./kendo.columnmenu.js";
import "./kendo.columnsorter.js";
import "./kendo.grid.js";
import "./kendo.listview.js";
import "./kendo.listbox.js";
import "./kendo.loader.js";
import "./kendo.filebrowser.js";
import "./kendo.imagebrowser.js";
import "./kendo.editor.js";
import "./kendo.numerictextbox.js";
import "./kendo.maskedtextbox.js";
import "./kendo.mediaplayer.js";
import "./kendo.menu.js";
import "./kendo.editable.js";
import "./kendo.pivot.fieldmenu.js";
import "./kendo.filter.js";
import "./kendo.filtercell.js";
import "./kendo.panelbar.js";
import "./kendo.progressbar.js";
import "./kendo.responsivepanel.js";
import "./kendo.tabstrip.js";
import "./kendo.timepicker.js";
import "./kendo.splitbutton.js";
import "./kendo.dropdownbutton.js";
import "./kendo.toolbar.js";
import "./kendo.datetimepicker.js";
import "./kendo.daterangepicker.js";
import "./kendo.treeview.draganddrop.js";
import "./kendo.treeview.js";
import "./kendo.scrollview.js";
import "./kendo.slider.js";
import "./kendo.splitter.js";
import "./kendo.upload.js";
import "./kendo.dialog.js";
import "./kendo.window.js";
import "./kendo.virtuallist.js";
import "./kendo.scheduler.view.js";
import "./kendo.scheduler.dayview.js";
import "./kendo.scheduler.agendaview.js";
import "./kendo.scheduler.monthview.js";
import "./kendo.scheduler.yearview.js";
import "./kendo.scheduler.recurrence.js";
import "./kendo.scheduler.js";
import "./kendo.gantt.data.js";
import "./kendo.gantt.editors.js";
import "./kendo.gantt.list.js";
import "./kendo.gantt.timeline.js";
import "./kendo.gantt.js";
import "./kendo.timeline.js";
import "./kendo.treelist.js";
import "./kendo.pivotgrid.js";
import "./kendo.spreadsheet.js";
import "./kendo.pivot.configurator.js";
import "./kendo.ripple.js";
import "./kendo.pdfviewer.js";
import "./kendo.rating.js";
import "./kendo.badge.js";
import "./kendo.filemanager.js";
import "./kendo.stepper.js";
import "./kendo.textarea.js";
import "./kendo.textbox.js";
import "./kendo.form.js";
import "./kendo.floatinglabel.js";
import "./kendo.tilelayout.js";
import "./kendo.wizard.js";
import "./kendo.appbar.js";
import "./kendo.imageeditor.js";
import "./kendo.expansionpanel.js";
import "./kendo.floatingactionbutton.js";
import "./kendo.inputgroupbase.js";
import "./kendo.radiogroup.js";
import "./kendo.checkboxgroup.js";
import "./kendo.bottomnavigation.js";
import "./kendo.actionsheet.js";
import "./kendo.actionsheet.view.js";
import "./kendo.skeletoncontainer.js";
import "./kendo.taskboard.js";
import "./kendo.captcha.js";
import "./kendo.orgchart.js";
import "./kendo.popover.js";
import "./kendo.toggleinputbase.js";
import "./kendo.checkbox.js";
import "./kendo.radiobutton.js";
import "./kendo.avatar.js";
import "./kendo.circularprogressbar.js";
import "./kendo.signature.js";
import "./kendo.timeselector.js";
import "./kendo.timedurationpicker.js";
import "./kendo.chip.js";
import "./kendo.chiplist.js";
import "./kendo.togglebutton.js";
import "./kendo.icons.js";
import "./kendo.dockmanager.js";
import "./kendo.aiprompt.js";
import "./kendo.propertygrid.js";
import "./kendo.otpinput.js";
import "./kendo.chartwizard.js";
import "./kendo.inlineaiprompt.js";
import "./kendo.smartpastebutton.js";
"bundle all";
export default kendo;
